(function ($) {
    'use strict';

    $(function () {
        $(document).on('gform_post_render', (event, formId) => {
            var $form = $(`#gform_${formId}`);
            var $submitButton = $form.find('button[type="submit"]');
            var $text = $form.find('.js-gform-submit-text');
            var originalLabel = $text.text();

            $submitButton.on('click', () => {
                $submitButton.addClass('is-submitting');
                $text.text('Sending Enquiry');
            });

            $(document).on('gform_confirmation_loaded', () => {
                $submitButton.removeClass('is-submitting');
                $submitButton.val(originalLabel);
            });
        });
    });
})(jQuery);
